<div class="example-menu" cdkMenu>
  <div class="custom-top-content">
    <ng-content></ng-content>
  </div>
  @for (item of items; track item) {
    @if (isToggleItem(item)) {
      <app-x-menu-item
        [leadingIcon]="item.leadingIcon"
        [withSelectIcon]="withSelectedIcons"
        [trailingIcon]="item.trailingIcon"
        [active]="active === item.id"
        [cdkMenuTriggerFor]="(!item.disabled && item.submenu) ? item.submenu : null"
        [submenu]="!!item.submenu"
        [isToggle]="item.isToggle"
        [toggleValue]="item.toggleValue"
        (toggleChange)="onItemClick(item)"
        [disabled]="item.disabled"
        [cdkMenuItemDisabled]="item.disabled"
        cdkMenuItemCheckbox
        [attr.aria-checked]="item.toggleValue"
        >{{ item.text }}</app-x-menu-item
      >
    } @else {
      <app-x-menu-item
        [leadingIcon]="item.leadingIcon"
        [withSelectIcon]="withSelectedIcons"
        [trailingIcon]="item.trailingIcon"
        [active]="active === item.id"
        [cdkMenuTriggerFor]="(!item.disabled && item.submenu) ? item.submenu : null"
        [submenu]="!!item.submenu"
        [disabled]="item.disabled"
        [cdkMenuItemDisabled]="item.disabled"
        (cdkMenuItemTriggered)="onItemClick(item)"
        cdkMenuItem
        >{{ item.text }}</app-x-menu-item
      >
    }
  }

  @if (secondItems.length > 0) {
    <app-x-divider [orientation]="'horizontal'" [showLine]="true" style="margin-bottom: 8px; height: 9px; padding-top: 9px"></app-x-divider>

    @for (item of secondItems; track item) {
      @if (isToggleItem(item)) {
        <app-x-menu-item
          [leadingIcon]="item.leadingIcon"
          [trailingIcon]="item.trailingIcon"
          [withSelectIcon]="withSelectedIcons"
          [active]="activeSecond === item.id"
          [cdkMenuTriggerFor]="(!item.disabled && item.submenu) ? item.submenu : null"
          [submenu]="!!item.submenu"
          [isToggle]="item.isToggle"
          [toggleValue]="item.toggleValue"
          (toggleChange)="onSecondItemClick(item)"
          [disabled]="item.disabled"
          [cdkMenuItemDisabled]="item.disabled"
          cdkMenuItemCheckbox
          [attr.aria-checked]="item.toggleValue"
          >{{ item.text }}</app-x-menu-item
        >
      } @else {
        <app-x-menu-item
          [leadingIcon]="item.leadingIcon"
          [trailingIcon]="item.trailingIcon"
          [withSelectIcon]="withSelectedIcons"
          [active]="activeSecond === item.id"
          [cdkMenuTriggerFor]="(!item.disabled && item.submenu) ? item.submenu : null"
          [submenu]="!!item.submenu"
          [disabled]="item.disabled"
          [cdkMenuItemDisabled]="item.disabled"
          (cdkMenuItemTriggered)="onSecondItemClick(item)"
          cdkMenuItem
          >{{ item.text }}</app-x-menu-item
        >
      }
    }
  }
</div>
